import { combineReducers } from '@reduxjs/toolkit';
import projects from './objectitemSlice';

const reducer = combineReducers({
	projects
});

export default reducer;
